import React, { useState } from 'react';
import { useMappedState } from 'redux-react-hook';
import { Icon, Tag, InputNumber, DatePicker, Select, Row, Col, Form } from 'antd';
import moment from 'moment';
import { format } from 'timeago.js';
import CustomAvatar from './../components/customAvatar';
import { allLocations, allCurrencys } from './../utils/invoices';
import { flexCenterRight, formItemLayoutInvoice } from './../theme';
import { getClient } from './../API';
import { s3 } from './../utils';
const { Option } = Select;

function CreateInvoiceForm({form, clients, candidates, offers, users, submitting}) {
  const session = useMappedState(state => state.session);
  const { getFieldDecorator } = form;

  const [clientLoading, setClientLoading] = useState(false);
  const [contacts, setContacts] = useState([]);
  
  const handleContact = (rule, value, callback) => {
    const { getFieldValue } = form;
    if (value && value === getFieldValue('contact')) {
      callback('Cannot be same to contact!');
    }
    callback();
  }

  const offerValidator = (rule, value, callback) => {
    const { getFieldValue } = form;
    const foundOffer = offers.find((i) => i.id === value);
    if (!value || getFieldValue('client') !== foundOffer.client_docs.id ||
        getFieldValue('candidate') !== foundOffer.candidate_docs.id) {
      callback('client / candidate not match!');
    }
    callback();
  }

  return (
    <div>
      <Row>
        <Col span={8}>
          <Form.Item {...formItemLayoutInvoice} label="Client">
            {getFieldDecorator('client', {
              rules: [{ required: true, message: 'Please select client!' }],
            })(
              <Select
                disabled={submitting}
                optionFilterProp={'label'}
                showSearch={true}
                placeholder="Select client"
                style={{ width: '100%' }}
                onChange={async (value) => {
                    setClientLoading(true);

                    // reset contact input
                    form.setFieldsValue({
                      cc: undefined,
                      contact: undefined,
                      additionalContact: undefined,
                    });

                    const response = await getClient(session.authToken, value);
                    setContacts(response.data.client.contacts);
                    setClientLoading(false);

                    await form.validateFields(['offer']);
                }}
              >
                {
                  clients.map((i) => (
                    <Option label={i.name} key={i.id} value={i.id}>
                      <CustomAvatar
                        colourCode={i.name.charAt(0).toLowerCase()}
                        char={i.name.charAt(0).toUpperCase()}
                        charSize={11}
                        size={26}
                        src={i.avatar}
                      />
                      &nbsp;&nbsp;{i.name}
                    </Option>
                  ))
                }
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...formItemLayoutInvoice} label="Contact">
            {getFieldDecorator('contact', {
              rules: [{ required: true, message: 'Please select contact!' }],
            })(
              <div>
                {
                  clientLoading ? (
                    <div>&nbsp;&nbsp;<Icon type="loading" />&nbsp;Loading...</div>
                  ) : (
                    <Select
                        disabled={submitting}
                        optionFilterProp={'label'}
                        showSearch={true}
                        placeholder="Select contact"
                        style={{ width: '100%' }}
                        onChange={(value) => {
                          form.setFieldsValue({
                            contact: value,
                          });
                        }}
                      >
                        {
                          contacts.map((i) => (
                            <Option label={`${i.firstname} ${i.lastname}`} key={i.id} value={i.id}>
                              <CustomAvatar
                                colourCode={i.firstname.charAt(0).toLowerCase()}
                                char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                                charSize={11}
                                size={26}
                                src={i.avatar}
                              />
                              &nbsp;&nbsp;{`${i.firstname} ${i.lastname}`}
                            </Option>
                          ))
                        }
                      </Select>
                  )
                }
              </div>
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...formItemLayoutInvoice} label="CC with Contact">
            {getFieldDecorator('cc', {})(
              <div>
                {
                  clientLoading ? (
                    <div>&nbsp;&nbsp;<Icon type="loading" />&nbsp;Loading...</div>
                  ) : (
                    <Select
                        mode="multiple"
                        disabled={submitting}
                        optionFilterProp={'label'}
                        showSearch={true}
                        placeholder="Select Contact CC"
                        style={{ width: '100%' }}
                        onChange={(value) => {
                          form.setFieldsValue({
                            cc: value,
                          });
                        }}
                      >
                        {
                          contacts.map((i) => (
                            <Option label={`${i.firstname} ${i.lastname}`} key={i.id} value={i.id}>
                              <CustomAvatar
                                colourCode={i.firstname.charAt(0).toLowerCase()}
                                char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                                charSize={11}
                                size={26}
                                src={i.avatar}
                              />
                              &nbsp;&nbsp;{`${i.firstname} ${i.lastname}`}
                            </Option>
                          ))
                        }
                      </Select>
                  )
                }
              </div>
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={8}>
          <Form.Item {...formItemLayoutInvoice} label="Other Contact">
            {getFieldDecorator('additionalContact', {
                rules: [
                  {
                    validator: handleContact
                  }
                ],
            })(
              <div>
                {
                  clientLoading ? (
                    <div>&nbsp;&nbsp;<Icon type="loading" />&nbsp;Loading...</div>
                  ) : (
                    <Select
                        allowClear
                        disabled={submitting}
                        optionFilterProp={'label'}
                        showSearch={true}
                        placeholder="Select other contact"
                        style={{ width: '100%' }}
                        onChange={(value) => {
                          form.setFieldsValue({
                            additionalContact: value,
                          });
                        }}
                      >
                        {
                          contacts.map((i) => (
                            <Option label={`${i.firstname} ${i.lastname}`} key={i.id} value={i.id}>
                              <CustomAvatar
                                colourCode={i.firstname.charAt(0).toLowerCase()}
                                char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                                charSize={11}
                                size={26}
                                src={i.avatar}
                              />
                              &nbsp;&nbsp;{`${i.firstname} ${i.lastname}`}
                            </Option>
                          ))
                        }
                      </Select>
                  )
                }
              </div>
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...formItemLayoutInvoice} label="Candidate">
            {getFieldDecorator('candidate', {
              rules: [{ required: true, message: 'Please select candidate!' }],
            })(
              <Select
                disabled={submitting}
                optionFilterProp={'label'}
                showSearch={true}
                placeholder="Select candidate"
                style={{ width: '100%' }}
                onChange={() => {
                  setTimeout(async() => {
                    await form.validateFields(['offer']);
                  }, 150);
                }}
              >
                {
                  candidates.map((i) => (
                    <Option label={`${i.firstname} ${i.lastname}`} key={i.id} value={i.id}>
                      <CustomAvatar
                        colourCode={i.firstname.charAt(0).toLowerCase()}
                        char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                        charSize={11}
                        size={26}
                        src={i.avatar}
                      />
                      &nbsp;&nbsp;{`${i.firstname} ${i.lastname}`}
                    </Option>
                  ))
                }
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...formItemLayoutInvoice} label="Location">
            {getFieldDecorator('location', {
              rules: [{ required: true, message: 'Please select location!' }],
            })(
              <Select
                disabled={submitting}
                showSearch={true}
                placeholder="Select location"
                style={{ width: '100%' }}
              >
                {
                  allLocations.map((i) => (
                    <Option key={i} value={i}>
                      {i}
                    </Option>
                  ))
                }
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={8}>
          <Form.Item {...formItemLayoutInvoice} label="On Board">
            {getFieldDecorator('onBoard', {
              rules: [{ required: true, message: 'Please select on board local time!' }],
            })(
              <DatePicker 
                disabled={submitting}
                style={{ width: '100%' }}
                placeholder="Select on board local time" />
            )}
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item {...formItemLayoutInvoice} label="Fee">
            {getFieldDecorator('fee', {
              rules: [{ required: true, message: 'Please input fee!' }],
            })(
              <InputNumber 
                disabled={submitting}
                placeholder="Input fee"
                style={{ width: '100%' }}
                min={1} max={1000000} />
            )}
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item {...formItemLayoutInvoice} label="Currency">
            {getFieldDecorator('currency', {
              rules: [{ required: true, message: 'Please select currency!' }],
            })(
              <Select
                disabled={submitting}
                showSearch={true}
                placeholder="Select currency"
                style={{ width: '100%' }}
              >
                {
                  allCurrencys.map((i) => (
                    <Option key={i} value={i}>
                      {i}
                    </Option>
                  ))
                }
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>

        <Row>
          <Col span={8}>
            <Form.Item {...formItemLayoutInvoice} label="Rebate Term">
              {getFieldDecorator('rebateTerm', {
                rules: [{ required: true, message: 'Please input rebate term days!' }],
              })(
                <InputNumber 
                  disabled={submitting}
                  style={{ width: '100%' }}
                  min={0} max={365} />
              )}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item {...formItemLayoutInvoice} label="Payment Term">
              {getFieldDecorator('paymentTerm', {
                rules: [{ required: true, message: 'Please input payment term days!' }],
              })(
                <InputNumber 
                  disabled={submitting}
                  style={{ width: '100%' }}
                  min={1} max={365} />
              )}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item {...formItemLayoutInvoice} label="Taken By">
              {getFieldDecorator('takenBy', {
                rules: [{ required: true, message: 'Please select recruiters!' }],
              })(
                <Select
                  disabled={submitting}
                  mode="multiple"
                  optionFilterProp={'label'}
                  showSearch={true}
                  placeholder="Select recruiters"
                  style={{ width: '100%' }}
                >
                  {
                    users.map((i) => (
                      <Option label={`${i.firstname} ${i.lastname}`} key={i._id} value={i._id}>
                        <CustomAvatar
                          colourCode={i.firstname.charAt(0).toLowerCase()}
                          char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                          charSize={11}
                          size={26}
                          src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${i.id}.jpeg`}
                        />
                        &nbsp;&nbsp;{`${i.firstname} ${i.lastname}`}
                      </Option>
                    ))
                  }
                </Select>
              )}
            </Form.Item>
          </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item 
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 22 }}
            label="Offer">
            {getFieldDecorator('offer', {
              rules: [
                { 
                  required: true, message: 'Please select offer!' 
                },
                {
                  validator: offerValidator,
                }
              ],
            })(
              <Select
                disabled={submitting}
                optionFilterProp={'label'}
                showSearch={true}
                placeholder="Select offer"
                style={{ width: '100%' }}
              >
                {
                  offers.map((i) => (
                    <Option label={`${i.client_docs.name} ${i.candidate_docs.firstname} ${i.candidate_docs.lastname}`} key={i.id} value={i.id}>
                      <Row>
                        <Col span={18}>
                          <CustomAvatar
                            colourCode={i.client_docs.name.charAt(0).toLowerCase()}
                            char={i.client_docs.name.charAt(0).toUpperCase()}
                            charSize={11}
                            size={26}
                            src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/client/${i.client_docs.id}.jpeg`}
                          />
                          &nbsp;&nbsp;{`${i.client_docs.name}`}
                          &nbsp;&nbsp;<Tag>{i.candidate_docs.firstname} {i.candidate_docs.lastname}</Tag>
                          &nbsp;&nbsp;<span>location: </span><i>{i.location}</i>
                          &nbsp;&nbsp;<span>position: </span><i>{i.position}</i>
                          &nbsp;&nbsp;<span>service: </span><i>{i.service}</i>
                          &nbsp;&nbsp;<span>salary: </span><i>{i.salary} / monthly</i>
                        </Col>
                        <Col span={6} style={flexCenterRight}>
                          <i style={{ fontSize: '12px', color: '#ccc' }}>
                            {format(new Date(moment(i.createdAt).format('YYYY-MM-DD HH:mm:ss')))}
                          </i>
                        </Col>
                      </Row>
                    </Option>
                  ))
                }
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
}

export default CreateInvoiceForm;
